'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import ProductListingPage from 'components/consumer/ProductListingPage';
import useClearancePageData from './hooks/useClearancePageData';
const ConsumerClearancePage = () => {
  const $ = _c(4);
  const pageData = useClearancePageData();
  let t0;
  if ($[0] !== pageData) {
    t0 = {
      ...pageData,
      layout: "minimal-with-attributes"
    };
    $[0] = pageData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const pageDataWithLayout = t0;
  let t1;
  if ($[2] !== pageDataWithLayout) {
    t1 = <ProductListingPage pageData={pageDataWithLayout} />;
    $[2] = pageDataWithLayout;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default ConsumerClearancePage;